import { render, staticRenderFns } from "./ChecklistBuilder.vue?vue&type=template&id=47f23ab2&"
import script from "./ChecklistBuilder.vue?vue&type=script&lang=js&"
export * from "./ChecklistBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports